export { GoogleMapsAPIWrapper } from './services/google-maps-api-wrapper';
export { CircleManager } from './services/managers/circle-manager';
export { InfoWindowManager } from './services/managers/info-window-manager';
export { MarkerManager } from './services/managers/marker-manager';
export { PolygonManager } from './services/managers/polygon-manager';
export { PolylineManager } from './services/managers/polyline-manager';
export { KmlLayerManager } from './services/managers/kml-layer-manager';
export { DataLayerManager } from './services/managers/data-layer-manager';
export { GoogleMapsScriptProtocol, LAZY_MAPS_API_CONFIG, LazyMapsAPILoader } from './services/maps-api-loader/lazy-maps-api-loader';
export { MapsAPILoader } from './services/maps-api-loader/maps-api-loader';
export { NoOpMapsAPILoader } from './services/maps-api-loader/noop-maps-api-loader';
//# sourceMappingURL=services.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@agm/core/services.js
// module id = 939
// module chunks = 13